import React, { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";

import { PROJECTS_NAMES_QUERY } from "src/constants/graphql/queries";
import useAuth from "src/hooks/useAuth";

export default function ProjectAutocomplete({ name = "projectId" }) {
  const { values, submitCount, getFieldMeta, setFieldTouched, setFieldValue } = useFormikContext();
  const { user } = useAuth();
  const { settings } = user.company;
  const label = `Assigned ${settings.filter_field2}`;
  const { data: { projects = [] } = {}, loading } = useQuery(PROJECTS_NAMES_QUERY);
  const projectOptions = useMemo(() => projects || [], [projects]);
  const value = values?.[name] ? projectOptions.find(p => p.id === values[name]) || null : null;
  const meta = getFieldMeta(name);
  const error = (meta.touched || submitCount > 0) && meta.error;

  return (
    <Autocomplete
      options={projectOptions}
      loading={loading}
      // Projects can share a name, and MUI keys rows by label by default.
      getOptionKey={option => option?.id}
      getOptionLabel={option => option?.name || ""}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      value={value}
      onChange={(_, v) => setFieldValue(name, v ? v.id : null)}
      onBlur={() => setFieldTouched(name, true, false)}
      renderInput={params => (
        <TextField {...params} label={label} size="small" error={!!error} helperText={error} />
      )}
    />
  );
}
